export default __webpack_public_path__ + "static/media/game-checker.abbd2b87.png";